<template>
  <UiAccordion class="accordion-card" :is-initially-expanded="true">
    <template #header> {{ accordionTitle }} </template>
    <template #content>
      <slot />
    </template>
  </UiAccordion>
</template>

<script setup lang="ts">
import UiAccordion from '@sephora-asia/ui-accordion/UiAccordion.vue'
import { capitalizeEachWord } from '~/utils/string-helpers'

const props = defineProps<{
  title: string
}>()

const accordionTitle = computed(() => {
  return capitalizeEachWord(props.title)
})
</script>

<style lang="scss" scoped>
.accordion-card {
  padding: 0 20px;
  :deep(.accordion-header) {
    padding-bottom: 0px;
    margin-bottom: 16px;
  }
}
</style>
